import { makeStyles, Theme } from '@material-ui/core/styles';

export const useStyles = makeStyles((theme: Theme) => ({
  topBar: {
    backgroundColor: '#F6F6F6',
    padding: '12px 24px ',
    '@media (max-width: 960px)': {
      padding: '8px 24px ',
    },
  },
  row: {
    alignItems: 'center',

    justifyContent: 'flex-start',
    padding: '24px',
    //marginBottom: theme.spacing(2),
    flexBasis: '45%',
    flexWrap: 'wrap',
    '& .MuiBox-root': {
      paddingTop: '0',
      paddingBottom: '0',
    },
    '@media (max-width: 1399px)': {
      flexBasis: '100%',
    },
  },
  blockbtn: {
    alignItems: 'center',
    justifyContent: 'flex-start',
    padding: '20px 24px 24px 24px',
    //marginBottom: theme.spacing(2),
    flexBasis: '45%',
    flexWrap: 'wrap',
    '& .MuiBox-root': {
      paddingTop: '0',
      paddingBottom: '0',
    },
    '@media (max-width: 1399px)': {
      flexBasis: '100%',
    },
    '@media (max-width: 960px)': {
      padding: '24px 24px 24px 24px',
    },
  },
  featuredetail: {
    // height: '100px',
    overflowY: 'auto',
    padding: '12px 0 12px 0px',
    display: 'flex',
  },
  featureSelect: {
    padding: '0 0 12px 0px',
    display: 'flex',
    justifyContent: 'space-between',
    borderTop: '1px solid',
  },
  block: {
    display: 'flex',
    justifyContent: 'space-between',
    width: '100%',
  },
  flexBox: {
    display: 'flex',
    //padding: '24px',
  },
  formContainer: {
    flex: 1,
  },
  btn1: {
    marginRight: '12px',
    marginTop: theme.spacing(1),
    padding: '12px 22px',
    '& .MuiButton-label': {
      textTransform: 'none',
    },
  },
  btn2: {
    marginLeft: '12px',
    marginTop: theme.spacing(1),
    padding: '12px 22px',
    '& .MuiButton-label': {
      textTransform: 'none',
    },
  },
  features: {
    borderTop: '1px solid',
    padding: '12px 0 0 0',
    fontSize: '16px',
    fontWeight: 500,
  },
  featureicons: {
    fontSize: '13px',
    marginRight: '8px',
    color: 'rgba(100, 201, 104, 1)',
  },
  featuredetailicon: {
    fontSize: '12px',
    paddingBottom: '12px',
  },
  selction1: {
    padding: '24px 16px 0 0 ',
  },
  selction2: {
    padding: '24px 0 0 16px',
  },
  selctionfull: {
    padding: '24px 0 0 0',
  },
  input: {
    minWidth: 250,
    flexGrow: 1,
    fontSize: 16,
    color: 'rgb(0 0 0 / 87%)',
    '& .MuiInputBase-input.Mui-disabled': {
      color: 'rgb(0 0 0 / 87%)',
    },
  },
  price: {
    fontSize: '20px',
    fontWeight: 600,
  },
  stripe: {
    background: 'white',
    padding: '12px',
    border: '1px solid rgba(0, 0, 0, 0.18)',
    '& span': {
      textTransform: 'uppercase',
      fontWeight: 600,
    },
  },
  coreFeatures: {
    height: '100px',
    overflowY: 'auto',
    '@media (max-width: 960px)': {
      height: '125px',
      overflowY: 'auto',
    },
  },
}));
